import axios from 'axios';

export const keycloackApi = axios.create({
  baseURL: window.ENV?.KEYCLOAK_ENDPOINT,
});
